import { IMenuItem } from "types/gaiaComponents/menu";
import { useContext } from "react";
import { ICON_SIZE } from "components/common/constants";
import { MenuItemChosenContext } from "components/common/menu/MenuContext";

export const MenuItem = (props: IMenuItem) => {
    const Icon = props.icon;
    const onItemChosen = useContext(MenuItemChosenContext);

    // A disabled button fires no click, so a disabled item is never reported as chosen
    const onClick = () => {
        props.onClick?.();
        onItemChosen?.();
    };

    const classNames = [
        "ga-menu__item",
        props.isSelected && "ga-menu__item--selected",
        props.isDisabled && "ga-menu__item--disabled",
        props.isActive && "ga-menu__item--active",
        props.className,
    ].filter(Boolean).join(" ");

    const label = <div className="ga-menu__item-label">{props.label}</div>;

    return (
        <button type="button"
                className={classNames}
                disabled={props.isDisabled}
                aria-label={props.ariaLabel}
                aria-current={props.isSelected || undefined}
                data-cy={props.dataCy}
                onClick={onClick}>
            {Icon && <Icon size={ICON_SIZE.SMALL} className="ga-menu__item-icon" aria-hidden="true"/>}
            <div className="ga-menu__item-content">
                {/* Gaia groups the label with its shortcut only when there is one */}
                {props.shortcut ? (
                    <div className="ga-menu__item-title">
                        {label}
                        <span className="ga-menu__item-shortcut">{props.shortcut}</span>
                    </div>
                ) : label}
                {props.description && <div className="ga-menu__item-description">{props.description}</div>}
            </div>
        </button>
    );
}
